import React, { useEffect, useState } from "react";
import cx from "classnames";
import styles from "./HeaderOfNote.module.css";
import Link from "next/link";
import { Snackbar } from "@mui/material";

import whatsappImage from "../../../images/NewsRoomImages/whatsappIcon.svg";
import telegreamImage from "../../../images/NewsRoomImages/telegramIcon.svg";
import emailImage from "../../../images/NewsRoomImages/emailIcon.svg";
import linkImage from "../../../images/NewsRoomImages/LinkIcon.svg";
import clockImage from "../../../images/NewsRoomImages/clockIcon.svg";
import Image from "next/image";
import { useRouter } from "next/router";

const HeaderOfNote = ({
  notePath,
  readingDuration,
  noteParagraphContent,
  noteTypeTitle,
  categoryTitle,
  categoryLink,
  noteDate,
  noteTitle,
}) => {
  const [openToast, setOpenToast] = useState(false);
  const [duration, setDuration] = useState(0);
  const [pagePath, setPagePath] = useState("");
  const router = useRouter();

  useEffect(() => {
    if (notePath) {
      if (readingDuration) {
        setDuration(readingDuration);
      } else {
        let calcedDuration = noteParagraphContent.split(" ").length;
        setDuration(Math.floor(calcedDuration / 275));
      }
      setPagePath(notePath);
    }
  }, [noteParagraphContent, readingDuration, notePath]);

  const onShareHandler = () => {
    if (pagePath) {
      navigator.clipboard.writeText(pagePath).then((res) => {
        openToastHandler();
      });
    }
  };

  // this section handles the showing tost for copy news link
  const openToastHandler = () => {
    setOpenToast(true);
  };
  const closeToastHandler = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToast(false);
  };
  return (
    <div className={cx(styles.container)}>
      <Snackbar
        open={openToast}
        autoHideDuration={2000}
        onClose={closeToastHandler}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        message={
          <div className="w-100 d-flex align-items-center justify-content-between">
            <span className={cx(styles.toasTextStyles, "d-flex", "w-100")}>
              {`لینک ${noteTypeTitle} کپی شد!`}
            </span>
          </div>
        }
      />
      <div
        className={cx(
          styles.topPageInfoContainer,
          "d-flex",
          "flex-column",
          "align-items-start",
          "justify-content-start"
        )}
      >
        <div className="w-100 d-flex align-items-center justify-content-start">
          {categoryLink && (
            <>
              <Link href={categoryLink} className={cx(styles.newsTagStyles)}>
                {categoryTitle}
              </Link>
              <span className={cx(styles.dateAndTagSeperator, "d-flex")}></span>
            </>
          )}
          <span className={cx(styles.newsDateStyles, "p-0 m-0")}>
            {noteDate}
          </span>
        </div>
        <h1 className={cx(styles.pageMainTitle, "p-0 m-0")}>{noteTitle}</h1>
        <div className="w-100 d-flex align-items-center justify-content-start">
          <Link
            className="me-2"
            target="_blank"
            href={`whatsapp://send?text=${pagePath}`}
            data-action="share/whatsapp/share"
          >
            <Image src={whatsappImage} alt="about digikala group" />
          </Link>

          <Link
            className="me-2"
            target="_blank"
            href={`https://t.me/share/url?url=${pagePath}&text=${noteTitle}`}
          >
            <Image src={telegreamImage} alt="about digikala group" />
          </Link>

          <Link
            className="me-2"
            target="_blank"
            href={`mailto:?subject=${noteTitle}-${pagePath}&amp;`}
            title="Share by Email"
          >
            <Image src={emailImage} alt="about digikala group" />
          </Link>

          <button
            onClick={onShareHandler}
            className={cx(
              styles.shareBtnSyles,
              "d-flex",
              "align-items-center",
              "justify-content-center",
              "me-5"
            )}
          >
            <Image src={linkImage} alt="about digikala group" />
          </button>

          <div className="d-flex align-items-center justify-content-center">
            <Image src={clockImage} alt="about digikala group" />
            <span
              className={cx(styles.timeAndTimeIconSeperator, "d-flex")}
            ></span>
            <span className={cx(styles.timeText, "d-flex")}>
              {duration + " "} دقیقه وقت خواندن
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderOfNote;
